export default "__VITE_ASSET__CdOCJyqr__"